var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('customer-form',{attrs:{"customer":_vm.customer,"creating":_vm.creating},on:{"delete":_vm.deleteCustomer,"update":_vm.updateCustomer}}),_vm._v(" "),_c('confirm',{ref:"confirm"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72fc11da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/customer-update.vue
// module id = null
// module chunks = 